import {isNullOrUndefined} from './is-null-or-undefined';

export function convertDateString(before: string): string {
  // assumes incoming format of 'yyyymmddxxxxxxxx' where x could or could not be the time

  if (isNullOrUndefined(before) || before === '') {
    return '';
  } else {
    const year = before.substring(0, 4);
    const month = before.substring(4, 6);
    const day = before.substring(6, 8);

    return month + '/' + day + '/' + year;
  }
}

export function convertDateStringToObject(before: string): Date {
  // assumes incoming format of 'yyyymmddxxxxxxxx' where x could or could not be the time

  if (isNullOrUndefined(before) || before === '') {
    return null;
  } else {
    const year = before.substring(0, 4);
    const month = before.substring(4, 6);
    const day = before.substring(6, 8);

    return new Date(parseInt(year, 10), (parseInt(month, 10) - 1), parseInt(day, 10));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/utils/convert-date-string.ts